import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import NotificationsIcon from '@mui/icons-material/Notifications';
import RedeemIcon from '@mui/icons-material/Redeem';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import PropTypes from 'prop-types';
import React from 'react';
import ReactGA4 from 'react-ga4';
import Responsive from 'react-responsive';
import { Nav, Navbar, NavItem, NavLink, Row } from 'reactstrap';

import { TabletWidth } from '../Common/const.jsx';
import SwitchToPaidConfirmModal from '../SwitchToPaid/SwitchToPaidConfirmModal.jsx';
import DailyQuiz from './DailyQuiz.jsx';
import Footer from './Footer.jsx';
import Logo from './Logo.jsx';

class Sidebar extends React.Component {
  state = {
    collapsed: this.props.collapsed,
    hover: false,
    openBecomePaid: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      collapsed: this.props.collapsed,
      hover: false,
      openBecomePaid: false,
    };
  }

  toggleCollapse = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  componentDidUpdate(oldProps) {
    const newProps = this.props;
    if (oldProps.collapsed !== newProps.collapsed) {
      this.setState({ collapsed: newProps.collapsed });
    }
  }

  onMouseEnterHandler = () => {
    if (window.innerWidth > TabletWidth) {
      this.setState({
        hover: true,
      });
    }
  };

  onMouseLeaveHandler = () => {
    if (window.innerWidth > TabletWidth) {
      this.setState({
        hover: false,
      });
    }
  };

  // Track how many people clicks on "Education Center" tab
  handleRouteClick = () => {
    // Google Analytics 4
    ReactGA4.event({
      category: 'Select',
      action: 'Education Center Tab Click',
      label: 'Education Center Tab Click',
    });
  };

  openBecomePaid = () => {
    this.setState({ openBecomePaid: true });
  };

  closeBecomePaid = () => {
    this.setState({ openBecomePaid: false });
  };

  createLinks = (routes, collapsed, pathName) => (
    <>
      {routes.map((prop, key) => {
        if (prop.name === 'Activate Subscription') {
          return (
            <NavItem key={key}>
              <NavLink
                className="nav-become-paid"
                onClick={this.openBecomePaid}
              >
                <i className={prop.icon} />
                {!collapsed ? (
                  <span className="d-none d-md-block">{prop.name}</span>
                ) : (
                  ''
                )}
              </NavLink>
            </NavItem>
          );
        }

        if (prop.name === 'Practice Exam') {
          return (
            <NavItem key={key}>
              <NavLink
                className="practice-exam-button mb-2 mt-2"
                href={prop.path}
              >
                <i className={prop.icon} />
                {!collapsed ? (
                  <span className="d-none d-md-block">{prop.name}</span>
                ) : (
                  ''
                )}
              </NavLink>
            </NavItem>
          );
        }

        // Option in menu is marked as active if
        // the item has the resource declared
        let active = false;
        prop.resources.forEach((resource) => {
          if (pathName.search(resource) !== -1) active = true;
        });

        const navClass = active ? 'active' : '';

        return (
          <NavItem key={key}>
            <NavLink
              className={
                prop.name === 'Education Center'
                  ? `${navClass} education-center-button mt-2`
                  : navClass
              }
              href={prop.path}
              data-test={prop.name.replaceAll(' ', '-').toLowerCase()}
            >
              {prop.icon === 'icon-activity' ? (
                <RedeemIcon className="margin-x-redeem" />
              ) : prop.icon === 'icon-notes' ? (
                <FlashOnIcon className="margin-x-flashMode" />
              ) : prop.icon === 'icon-education-center' ? (
                <SchoolOutlinedIcon className="margin-x-flashMode" />
              ) : prop.icon === 'icon-submit-question' ? (
                <EmojiObjectsIcon className="margin-x-flashMode" />
              ) : prop.icon === 'icon-bell' ? (
                <NotificationsIcon className="margin-x-flashMode" />
              ) : prop.icon === 'icon-refer-friend' ? (
                <GroupAddIcon className="margin-x-flashMode" />
              ) : (
                <i className={`${prop.icon} active`} />
              )}
              {!collapsed && prop.name === 'Education Center' ? (
                <span
                  onClick={() => this.handleRouteClick(true)}
                  className="d-none d-md-block"
                >
                  {prop.name}
                </span>
              ) : !collapsed ? (
                <span className="d-none d-md-block">{prop.name}</span>
              ) : (
                ''
              )}
            </NavLink>
          </NavItem>
        );
      })}
    </>
  );

  render() {
    const routes = [];

    if (
      this.props.userSubscription &&
      this.props.userSubscription.status === 'trialing'
    ) {
      routes.push({
        path: '/#/',
        name: 'Activate Subscription',
        icon: 'icon-star icon-become-paid',
        resources: [],
      });
    }

    // EDUCATION CENTER ROUTE
    routes.push({
      path: '/#/app/education-center',
      name: 'Education Center',
      icon: 'icon-education-center',
      resources: ['education-center'],
    });

    // PRACTICE EXAM
    routes.push({
      path: '#/app/exams',
      name: 'Practice Exam',
      icon: 'icon-practice',
      resources: ['practice-exam'],
    });

    // DASHBOARD ROUTE
    routes.push({
      path: '/#/app/dashboard',
      name: 'Dashboard',
      icon: 'icon-profile',
      resources: ['dashboard'],
    });

    // STUDY ROUTE
    let studyRoute = null;
    if (this.props.user && this.props.user.id) {
      studyRoute = {
        path: '/#/app/study',
        name: 'Study',
        icon: 'icon-study',
        resources: ['study', '/app/question'],
      };
    } else {
      studyRoute = {
        path: `#${this.props.pathName}`,
        name: 'Study',
        icon: 'icon-study',
        resources: ['study', '/app/question'],
      };
    }

    routes.push(studyRoute);

    // FLIGHT LOG ROUTE
    let flightlogRoute = null;
    flightlogRoute = {
      path: '/#/app/notifications',
      name: 'Flight Log',
      icon: 'icon-bell',
      resources: ['Notifications', '/app/notifications'],
    };

    routes.push(flightlogRoute);

    // RESOURCES ROUTES
    // Temporarily hide "Resources" from the sidebar.
    routes.push({
      path: '/#/app/submit-question',
      name: 'Submit a question',
      icon: 'icon-submit-question',
      resources: ['submit-question'],
    });

    // REFER A FRIEND ROUTE
    routes.push({
      path: '/#/app/refer-a-friend',
      name: 'Refer a Friend',
      icon: 'icon-refer-friend',
      resources: ['refer-a-friend'],
    });

    // add the collapsed class for size
    const navClasses = `navbar-vertical navbar-vertical-fixed fixed-left navbar-light bg-white flex-row align-items-start  ${
      this.state.collapsed ? 'collapsed' : 'expanded'
    }${window.location.hash === '#/app/practice-exam' ? ' d-none' : ' d-flex'}`;
    const collapsed = this.state.collapsed;
    return (
      <>
        {/* invisible svg for declaring the gradient for mui icons */}
        <svg width="0" height="0" style={{ position: 'absolute' }}>
          <linearGradient
            id="sidebar-gradient-fill"
            x1="0"
            y1="1"
            x2="1"
            y2="0"
          >
            <stop stopColor="#d6083b" offset="0%" />
            <stop stopColor="#d6083b80" offset="100%" />
          </linearGradient>
        </svg>

        <Responsive minDeviceWidth={800}>
          <Navbar
            className={navClasses}
            onMouseEnter={this.onMouseEnterHandler}
            onMouseLeave={this.onMouseLeaveHandler}
            style={{ gap: '20px' }}
          >
            <div>
              <Logo collapsed={!this.state.hover && this.state.collapsed} />
            </div>

            {/* {window.location.hash !== '#/app/daily-quiz' && ( */}
            <Row
              className={
                this.state.collapsed && !(window.innerWidth > TabletWidth)
                  ? 'quiz_spacer m-0 w-100'
                  : 'mx-auto quiz_spacer'
              }
            >
              <div>
                <DailyQuiz
                  {...this.props}
                  pfeSktId={this.props.pfeSktId}
                  TabletWidth={TabletWidth}
                  buttonText="Launch Quiz"
                  toggleSidebar={this.toggleCollapse}
                  initialCollapsedState={this.props.collapsed}
                  hover={this.state.hover}
                  collapsed={this.state.collapsed}
                  availableQuiz={this.props.availableQuiz}
                  startTimer={this.props.startTimer}
                  timer={this.props.timer}
                  checkDailyQuizStatus={this.props.checkDailyQuizStatus}
                  checkDailyQuizStatusWaiting={
                    this.props.checkDailyQuizStatusWaiting
                  }
                  nextQuizIn={this.props.nextQuizIn}
                  dailyQuizRunning={this.props.dailyQuizRunning}
                  setDailyTimeOut={this.props.setDailyTimeOut}
                  dailyTimeOut={this.props.dailyTimeOut}
                  quiz={this.props.quiz}
                  userSubscription={this.props.userSubscription}
                  setFlashSectionChoose={this.props.setFlashSectionChoose}
                  qualDailyQuizTimeout={this.props.qualDailyQuizTimeout}
                  setQualDailyQuiz={this.props.setQualDailyQuiz}
                  setOneQualDailyQuizHistory={
                    this.props.setOneQualDailyQuizHistory
                  }
                />
              </div>
            </Row>
            {/* )} */}
            <div className="navbar-wrapper">
              <Nav navbar>
                {this.createLinks(
                  routes,
                  !this.state.hover && collapsed,
                  this.props.pathName,
                )}
              </Nav>
            </div>

            <Footer collapsed={!this.state.hover && this.state.collapsed} />
          </Navbar>
        </Responsive>
        <SwitchToPaidConfirmModal
          isOpen={this.state.openBecomePaid}
          user={this.props.user}
          userSubscription={this.props.userSubscription}
          onClose={this.closeBecomePaid}
          activateSubscription={this.props.activateSubscription}
          subscriptionActivationSucces={this.props.subscriptionActivationSucces}
          subscriptionActivationWaiting={
            this.props.subscriptionActivationWaiting
          }
          subscriptionActivationMessage={
            this.props.subscriptionActivationMessage
          }
        />
      </>
    );
  }
}

DailyQuiz.propTypes = {
  quizAvailable: PropTypes.bool,
  startTimer: PropTypes.func,
  pathName: PropTypes.string,
};

export default Sidebar;
